/* eslint-disable no-unused-vars */
import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { orderSummaryAPI } from '../../../api/Api';
import { loginToken } from '../../../authorization/login';
import DokanCard from '../../../components/card/DokanCard';
import DokanSmallCard from '../../../components/card/DokanSmallCard';
import { fetchData } from '../../../hooks/fetchData';
import { fetchOrdersSummary } from '../../../redux/orders/ordersActions';

const OrdersHighlights = () => {
    // const [ordersSummary, setOrdersSummary] = useState({});
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchOrdersSummary());
    }, [dispatch]);

    const ordersSummary = useSelector((state) => state.orders.ordersSummary);

    return (
        <DokanCard disableMargin hasTitle cardTitle="Orders">
            <div className="text-sm text-primary font-medium">
                <Row gutter={[20, 20]}>
                    <Col xs={12} sm={12} md={8}>
                        <DokanSmallCard
                            label="Total"
                            labelColor="text-violet"
                            value={ordersSummary?.total}
                        />
                    </Col>
                    <Col xs={12} sm={12} md={8}>
                        <DokanSmallCard
                            label="Completed"
                            labelColor="text-green"
                            value={[ordersSummary?.['wc-completed']]}
                        />
                    </Col>
                    <Col xs={12} sm={12} md={8}>
                        <DokanSmallCard
                            label="Pending"
                            labelColor="text-blue"
                            value={[ordersSummary?.['wc-pending']]}
                        />
                    </Col>

                    <Col xs={12} sm={12} md={8}>
                        <DokanSmallCard
                            label="Processing"
                            labelColor="text-orange"
                            value={[ordersSummary?.['wc-processing']]}
                        />
                    </Col>
                    <Col xs={12} sm={12} md={8}>
                        <DokanSmallCard
                            label="Cancelled"
                            labelColor="text-red-darkRed"
                            value={[ordersSummary?.['wc-cancelled']]}
                        />
                    </Col>
                    <Col xs={12} sm={12} md={8}>
                        <DokanSmallCard
                            label="Refunded"
                            labelColor="text-red-darkRed"
                            value={[ordersSummary?.['wc-refunded']]}
                        />
                    </Col>

                    <Col xs={12} sm={12} md={8}>
                        <DokanSmallCard
                            label="On Hold"
                            labelColor="text-yellow"
                            value={[ordersSummary?.['wc-on-hold']]}
                        />
                    </Col>
                    <Col xs={12} sm={12} md={8}>
                        <DokanSmallCard
                            label="Failed"
                            labelColor="text-red-darkRed"
                            value={[ordersSummary?.['wc-failed']]}
                        />
                    </Col>
                    <Col xs={12} sm={12} md={8}>
                        <DokanSmallCard
                            label="On-back-Order"
                            labelColor="text-yellow"
                            value={[ordersSummary?.['wc-refunded']]}
                        />
                    </Col>
                </Row>
            </div>
        </DokanCard>
    );
};

export default OrdersHighlights;
